import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
import constants from '../constants'
import store from '@/store'

const apiUrl = constants.apiUrl;
const maxAttempts = 10;
const attemps = {};

export default {
    async startConnection(hubPath, handlers = {}) {
        let connection = new HubConnectionBuilder()
            .withUrl(apiUrl + hubPath)
            .configureLogging(LogLevel.Error)
            .build();

        for (const ev in handlers) {
            connection.on(ev, handlers[ev]);
        }

        async function start() {
            try {
                await connection.start();
                attemps[hubPath] = 0;
            } catch (err) {
                console.error(err);

                if(attemps[hubPath]){
                    attemps[hubPath]++;
                } else {
                    attemps[hubPath] = 1;
                }

                store.commit("requestEnds", hubPath);
                await new Promise(r => setTimeout(r, 1000));

                if(attemps[hubPath] <= maxAttempts){
                    await start();
                }                  
            }
        }

        connection._forceClose = false;
        connection.close = async function () {
            connection._forceClose = true;
            await connection.stop();
        }
        connection.onclose(async () => !connection._forceClose && await start());

        store.commit("requestStarts", hubPath);
        await start();
        setTimeout(function(){
            store.commit("requestEnds", hubPath);
        }, 50);

        return connection;
    }
}